"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CHECKED = _spauiUtils.nodeTree.CHECKED,
    INDETERMINATE = _spauiUtils.nodeTree.INDETERMINATE,
    UNCHECKED = _spauiUtils.nodeTree.UNCHECKED;

var TreeBranchDomComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TreeBranchDomComponent, _React$PureComponent);

  function TreeBranchDomComponent(props) {
    var _this;

    _classCallCheck(this, TreeBranchDomComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TreeBranchDomComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setScrollContainerRef", function (element) {
      _this.scrollContainerEle = element;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollChangeNodeToView", function () {
      var prevData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var currentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var firstChangeValue = null; // 获取第一个变化的元素

      for (var index = 0; index < currentData.length; index++) {
        var prevItem = prevData[index];
        var currentItem = currentData[index];
        var prevItemStatus = prevItem ? prevItem.status : '';
        var currentItemStatus = currentItem ? currentItem.status : ''; // 两种情况，一种是之前这一列没有展开，所以 prevData 是没有数据的。还有一种是这一列是已经展开了，但是没有选中任何项

        if (prevItem && currentItem && currentItemStatus != prevItemStatus && prevItemStatus == UNCHECKED && (currentItemStatus == CHECKED || currentItemStatus == INDETERMINATE) || typeof prevItem === 'undefined' && currentItem && (currentItemStatus == CHECKED || currentItemStatus == INDETERMINATE)) {
          firstChangeValue = currentItem.value;
          break;
        }
      } // 看改变的第一个值是否在滚动区域内，如果不是，将该选项滚动到区域内


      var _assertThisInitialize = _assertThisInitialized(_this),
          scrollContainerEle = _assertThisInitialize.scrollContainerEle;

      if (firstChangeValue != null && scrollContainerEle && scrollContainerEle.querySelector) {
        var itemElement = scrollContainerEle.querySelector("li[data-value=\"".concat(firstChangeValue, "\"]"));

        if (itemElement) {
          var itemOffsetTop = itemElement.offsetTop;
          var itemOffsetHeight = itemElement.offsetHeight;
          var viewOffsetTop = scrollContainerEle.scrollTop;
          var scrollContainerHeight = scrollContainerEle.offsetHeight;
          var viewOffsetBottom = viewOffsetTop + scrollContainerHeight; // 如果不在滚动区域内, 调整滚动距离到该元素出现在顶部

          if (!(itemOffsetTop >= viewOffsetTop && itemOffsetTop <= viewOffsetBottom)) {
            scrollContainerEle.scrollTop = itemOffsetTop - scrollContainerHeight / 2 - itemOffsetHeight / 2;
          }
        }
      }
    });

    _this.setScrollContainerRef = _this.setScrollContainerRef.bind(_assertThisInitialized(_this)); // 进行防抖处理，防止多次render，只需要处理最后一次（40ms是为了防止元素还没有完全渲染完，去获取高度信息有误）

    _this.scrollChangeNodeToView = (0, _spauiUtils.debounce)(_this.scrollChangeNodeToView, 40);
    _this.setSelectedValueToViewTimeoutInstance = null;
    return _this;
  }

  _createClass(TreeBranchDomComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props$setSelect = this.props.setSelectedValueToViewTimeout,
          setSelectedValueToViewTimeout = _this$props$setSelect === void 0 ? 0 : _this$props$setSelect;

      if (this.props.setSelectedValueToView) {
        clearTimeout(this.setSelectedValueToViewTimeoutInstance);
        this.setSelectedValueToViewTimeoutInstance = setTimeout(function () {
          _this2.scrollChangeNodeToView([], _this2.props.data || []);
        }, setSelectedValueToViewTimeout);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var _this$props$setSelect2 = this.props.setSelectedValueToViewTimeout,
          setSelectedValueToViewTimeout = _this$props$setSelect2 === void 0 ? 0 : _this$props$setSelect2;

      if (this.props.setSelectedValueToView) {
        clearTimeout(this.setSelectedValueToViewTimeoutInstance);
        this.setSelectedValueToViewTimeoutInstance = setTimeout(function () {
          _this3.scrollChangeNodeToView(prevProps.data || [], _this3.props.data || []);
        }, setSelectedValueToViewTimeout);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scrollContainerEle = null;

      if (this.setSelectedValueToViewTimeoutInstance) {
        clearTimeout(this.setSelectedValueToViewTimeoutInstance);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          onScroll = _this$props.onScroll,
          _this$props$data = _this$props.data,
          data = _this$props$data === void 0 ? [] : _this$props$data,
          _this$props$showBegin = _this$props.showBeginIndex,
          showBeginIndex = _this$props$showBegin === void 0 ? 0 : _this$props$showBegin,
          _this$props$children = _this$props.children,
          children = _this$props$children === void 0 ? [] : _this$props$children,
          theNumberOfDisplay = _this$props.theNumberOfDisplay,
          index = _this$props.index,
          displayItemHeight = _this$props.displayItemHeight,
          setBranchTitle = _this$props.setBranchTitle,
          setBranchBottomContent = _this$props.setBranchBottomContent,
          setPlaceholderBranchContent = _this$props.setPlaceholderBranchContent,
          _this$props$branchTit = _this$props.branchTitleClassName,
          branchTitleClassName = _this$props$branchTit === void 0 ? '' : _this$props$branchTit,
          parentNode = _this$props.parentNode,
          _this$props$className2 = _this$props.classNameMap,
          classNameMap = _this$props$className2 === void 0 ? {} : _this$props$className2,
          setBranchCheckAll = _this$props.setBranchCheckAll,
          isEmptyTreeBranch = _this$props.isEmptyTreeBranch,
          _this$props$loadingBr = _this$props.loadingBranches,
          loadingBranches = _this$props$loadingBr === void 0 ? [] : _this$props$loadingBr,
          PlaceholderBranchComponent = _this$props.PlaceholderBranchComponent; // 当前该 branch 正在加载

      if (loadingBranches.includes(index)) {
        return _react["default"].createElement(PlaceholderBranchComponent, {
          isLoading: true,
          index: index,
          data: data,
          parentNode: parentNode,
          className: className,
          style: style,
          classNameMap: classNameMap
        });
      } // 占位的 branch


      if (isEmptyTreeBranch && PlaceholderBranchComponent) {
        var content = null;

        if ((0, _spauiUtils.isFunction)(setPlaceholderBranchContent)) {
          content = setPlaceholderBranchContent(index, data, parentNode);
        }

        return _react["default"].createElement(PlaceholderBranchComponent, {
          index: index,
          data: data,
          parentNode: parentNode,
          className: className,
          style: style,
          classNameMap: classNameMap,
          content: content
        });
      } // 20是留点空间，避免真的就是跟展示数据一模一样，一样的话滚动的时候容易有问题


      var showPlacementDiv = theNumberOfDisplay > 0 && Math.floor(data.length / (theNumberOfDisplay + 20)) >= 2;
      var title = (0, _spauiUtils.isFunction)(setBranchTitle) ? setBranchTitle(index, data, parentNode) : null;
      var checkAll = (0, _spauiUtils.isFunction)(setBranchCheckAll) ? setBranchCheckAll(index, data, parentNode) : undefined;

      var handleScroll = function handleScroll(event) {
        var triggerScrollCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (triggerScrollCallback && (0, _spauiUtils.isFunction)(onScroll)) {
          onScroll(event, index);
        }
      };

      var bottomContent = null;

      if ((0, _spauiUtils.isFunction)(setBranchBottomContent)) {
        bottomContent = setBranchBottomContent(index, data, parentNode);
      }

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, _defineProperty({}, classNameMap.TreeScopeHaveTitleClassName, title)),
        style: style,
        onScroll: function onScroll(event) {
          return handleScroll(event, !title);
        },
        ref: !title ? this.setScrollContainerRef : undefined
      }, title ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classNameMap.TreeScopeTitleClassName, branchTitleClassName)
      }, title) : null, showPlacementDiv ? _react["default"].createElement("div", {
        style: {
          height: "".concat(showBeginIndex * displayItemHeight, "px")
        }
      }) : null, _react["default"].createElement("ul", {
        className: "list-with-select",
        onScroll: function onScroll(event) {
          return handleScroll(event, title);
        },
        ref: title ? this.setScrollContainerRef : undefined
      }, children.map(function (item) {
        // 全选结构
        if (_typeof(item) === 'object' && item && item.props && item.props.checkAll) {
          var unCheckAll = typeof checkAll !== 'undefined' && !checkAll;

          if (typeof checkAll === 'undefined' && index > 0 || unCheckAll) {
            return null;
          }
        } // 数据选项结构


        if (showPlacementDiv && (0, _spauiUtils.isArray)(item)) {
          return item.map(function (subItem, subChildIndex) {
            if (showPlacementDiv && (subChildIndex < showBeginIndex || subChildIndex > showBeginIndex + theNumberOfDisplay)) {
              return null;
            }

            return subItem;
          });
        }

        return item;
      })), bottomContent, showPlacementDiv ? _react["default"].createElement("div", {
        style: {
          height: "".concat((data.length - (showBeginIndex + theNumberOfDisplay)) * displayItemHeight, "px")
        }
      }) : null);
    }
  }]);

  return TreeBranchDomComponent;
}(_react["default"].PureComponent);
/**
 * 默认树状选择器Branch组件
 * @param props
 * @returns {XML}
 * @constructor
 */


var TreeBranchComponent = function TreeBranchComponent(_ref) {
  var parentNode = _ref.parentNode,
      branchWidthStyle = _ref.branchWidthStyle,
      BranchTreeNodeComponent = _ref.BranchTreeNodeComponent,
      onColumnScroll = _ref.onColumnScroll,
      theNumberOfDisplay = _ref.theNumberOfDisplay,
      displayItemHeight = _ref.displayItemHeight,
      setBranchTitle = _ref.setBranchTitle,
      setBranchBottomContent = _ref.setBranchBottomContent,
      setPlaceholderBranchContent = _ref.setPlaceholderBranchContent,
      branchTitleClassName = _ref.branchTitleClassName,
      _ref$classNameMap = _ref.classNameMap,
      classNameMap = _ref$classNameMap === void 0 ? {} : _ref$classNameMap,
      multiple = _ref.multiple,
      checkAll = _ref.checkAll,
      checkAllLabel = _ref.checkAllLabel,
      checkAllDataSet = _ref.checkAllDataSet,
      CheckAllComponent = _ref.CheckAllComponent,
      valueTreeNodeMap = _ref.valueTreeNodeMap,
      _ref$checkAllProps = _ref.checkAllProps,
      checkAllProps = _ref$checkAllProps === void 0 ? {} : _ref$checkAllProps,
      _ref$nodeNotAllowSele = _ref.nodeNotAllowSelected,
      nodeNotAllowSelected = _ref$nodeNotAllowSele === void 0 ? false : _ref$nodeNotAllowSele,
      setBranchCheckAll = _ref.setBranchCheckAll,
      selectTarget = _ref.selectTarget,
      autoAlignment = _ref.autoAlignment,
      _ref$fieldNames = _ref.fieldNames,
      fieldNames = _ref$fieldNames === void 0 ? {} : _ref$fieldNames,
      _ref$unRelatedDisable = _ref.unRelatedDisabled,
      unRelatedDisabled = _ref$unRelatedDisable === void 0 ? false : _ref$unRelatedDisable,
      _ref$isEmptyTreeBranc = _ref.isEmptyTreeBranch,
      isEmptyTreeBranch = _ref$isEmptyTreeBranc === void 0 ? false : _ref$isEmptyTreeBranc,
      _ref$loadingBranches = _ref.loadingBranches,
      loadingBranches = _ref$loadingBranches === void 0 ? [] : _ref$loadingBranches,
      PlaceholderBranchComponent = _ref.PlaceholderBranchComponent,
      setSelectedValueToView = _ref.setSelectedValueToView;
  var disabled = checkAllProps.disabled;
  var _fieldNames$disabledF = fieldNames.disabledFieldName,
      disabledFieldName = _fieldNames$disabledF === void 0 ? 'disabled' : _fieldNames$disabledF;
  var isAllSelected = parentNode.status === CHECKED;
  var childrenNodes = parentNode && parentNode.childrenNodes && parentNode.childrenNodes || [];

  var onScroll = function onScroll(event, index) {
    if ((0, _spauiUtils.isFunction)(onColumnScroll) && event.target) {
      var scrollTop = event.target.scrollTop;
      var visibleHeight = event.target.clientHeight;
      var scrollHeight = event.target.scrollHeight;
      onColumnScroll(event, parentNode, [scrollTop, scrollTop + visibleHeight], scrollHeight, childrenNodes, index);
    }
  }; // 如果父节点是选中状态, 那么子节点全选中
  // 同时 不展示选中的动画, 防止闪动


  var customClassName = (0, _classnames["default"])(classNameMap.TreeScopeClassName, {
    noanimation: isAllSelected
  }); // 判断是否选中

  var isChecked = function isChecked() {
    var result = false;
    var ok = false;

    if ((0, _spauiUtils.isArray)(childrenNodes) && childrenNodes.length > 0) {
      result = true;
      childrenNodes.map(function (item) {
        if (item && !item.disabled && !item.not_allow_selected && (item.value || typeof item.value === 'number') && !(typeof item.isAllowSelected !== 'undefined' && !item.isAllowSelected)) {
          if (item.status !== CHECKED) {
            result = false;
          }

          ok = true;
        }

        return item;
      }); // 如果没有一列是ok的，那就要重新变成false

      if (!ok) {
        result = false;
      }
    }

    return result;
  };

  var isIndeterminate = function isIndeterminate() {
    var result = false;

    if (!isChecked() && (0, _spauiUtils.isArray)(childrenNodes) && childrenNodes.length > 0) {
      childrenNodes.map(function (item) {
        if (item && item.status === CHECKED) {
          result = true;
        }

        return item;
      });
    }

    return result;
  }; // 如果同时存在可选择的选项和不可选择的选项，则这里每个选项的边缘需要对齐


  var selectAlignment = false;

  if (autoAlignment && parentNode.childrenNodes && parentNode.childrenNodes.length > 0) {
    var canSlectNumber = 0;
    parentNode.childrenNodes.forEach(function (itemNode) {
      var canSelect = false;

      if (typeof itemNode.isAllowSelected !== 'undefined') {
        canSelect = itemNode.isAllowSelected;
      } else {
        var notAllowSelected = selectTarget === 'child' && itemNode && itemNode.childrenNodes && itemNode.childrenNodes.length > 0;
        var canSelectedItem = !(nodeNotAllowSelected || itemNode.not_allow_selected || notAllowSelected || typeof itemNode.value === 'string' && itemNode.value.length < 1); // 可以通过函数进行二次判断

        if ((0, _spauiUtils.isFunction)(checkAllProps.canSelected)) {
          canSelectedItem = checkAllProps.canSelected(itemNode, canSelectedItem);
        }

        canSelect = canSelectedItem;
      }

      if (canSelect) {
        canSlectNumber = canSlectNumber + 1;
      }
    });

    if (canSlectNumber > 0 && canSlectNumber < parentNode.childrenNodes.length) {
      selectAlignment = true;
    }
  } // 当前层级的节点是否全部都是禁止选择的


  var isChildAllDisabled = (0, _spauiUtils.isArray)(childrenNodes) && childrenNodes.every(function (item) {
    return !!item[disabledFieldName];
  }); // 全选按钮是否禁止选中（先看父节点是否禁止选中 => 再看当前层级所有节点是否都是禁止选中 => 最后再看这个组件是否禁止操作）

  var checkAllDisabled = Boolean(parentNode && parentNode[disabledFieldName] && !unRelatedDisabled) || isChildAllDisabled && !unRelatedDisabled || disabled;
  return _react["default"].createElement(TreeBranchDomComponent, {
    classNameMap: classNameMap,
    className: customClassName,
    style: branchWidthStyle,
    onScroll: onScroll,
    parentNode: parentNode,
    data: childrenNodes,
    theNumberOfDisplay: theNumberOfDisplay,
    displayItemHeight: displayItemHeight,
    setBranchTitle: setBranchTitle,
    setBranchBottomContent: setBranchBottomContent,
    setPlaceholderBranchContent: setPlaceholderBranchContent,
    setBranchCheckAll: setBranchCheckAll,
    branchTitleClassName: branchTitleClassName,
    setSelectedValueToView: setSelectedValueToView,
    isEmptyTreeBranch: isEmptyTreeBranch,
    loadingBranches: loadingBranches,
    PlaceholderBranchComponent: PlaceholderBranchComponent
  }, multiple && checkAll && !nodeNotAllowSelected ? _react["default"].createElement(CheckAllComponent, _extends({}, checkAllProps, {
    checked: isChecked(),
    indeterminate: isIndeterminate(),
    valueTreeNodeMap: valueTreeNodeMap,
    checkAll: checkAll,
    checkAllLabel: checkAllLabel,
    checkAllDataSet: checkAllDataSet,
    data: childrenNodes,
    disabled: checkAllDisabled
  })) : null, // 同步触发下渲染子结构
  childrenNodes.map(function (item) {
    return BranchTreeNodeComponent(item, {
      selectAlignment: selectAlignment
    });
  }));
};

var _default = TreeBranchComponent;
exports["default"] = _default;